import axios from 'axios';

import IComposableDashboard from '../types/IComposableDashboardContext';

const url = 'wsreporting/api/';

export const pinDashboard = (dashboardId: string) =>
  axios.post(`${url}pin-dashboard/${dashboardId}`);

export const unPinDashboard = (dashboardId: string) =>
  axios.delete(`${url}pin-dashboard/${dashboardId}`);

export const getMyPinnedDashboards = () => axios.get(`${url}my-pinned-dashboards`);

export const getPinnedDashboardsCreatedByCurrentUser = () =>
  axios.get(`${url}all-pinned-dashboards`);

export const assignDashboard = (dashboard: IComposableDashboard) =>
  axios.post(`${url}assign-dashboard`, dashboard);

export const unAssignDashboard = (dashboardId: string) =>
  axios.delete(`${url}assign-dashboard/${dashboardId}`);
